import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';

import { Button } from '@/components/Button';
import { SelectorContainer } from '@/components/SelectorContainer';
import { getProvidersForAppointmentType } from '@/lib/helpers/appointmentTypes';
import { useBookingStore } from '@/store/useBookingStore';
import { usePracticeStore } from '@/store/usePracticeStore';
import { DearDocProvider } from '@/types/api.types';

import styles from './DoctorSelector.module.css';

export const DoctorSelector = () => {
  const { provider, setProvider, appointmentType } = useBookingStore();
  const { providers, connection } = usePracticeStore();
  const [availableProviders, setAvailableProviders] = useState<DearDocProvider[]>(providers);

  useEffect(() => {
    if (appointmentType) {
      const filteredProviders = getProvidersForAppointmentType(providers, appointmentType);
      setAvailableProviders(filteredProviders);
    }
  }, [appointmentType, providers]);

  useEffect(() => {
    if (connection?.skipProviderSelection && providers.length === 1) {
      setProvider(providers[0].id, providers);
    }
  }, [connection, providers, setProvider]);

  useEffect(() => {
    if (import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID) {
      ReactGA.send({
        hitType: 'pageview',
        page: window.location.pathname,
        title: 'Doctor Selector',
      });
    }
  }, []);

  const handleClick = (id: string) => {
    const newId = provider?.id === id ? '' : id;
    setProvider(newId, providers);
  };

  return (
    <SelectorContainer text="Please start by selecting a doctor:" data-testid="providers">
      {availableProviders &&
        availableProviders.length > 0 &&
        availableProviders.map(({ id, name, provider_profile_image_url }) => (
          <Button
            key={`doctor-${id}`}
            isActive={id === provider?.id}
            onClick={() => handleClick(id)}
            data-testid="doctor-slot"
            className={styles.btn}
          >
            <img className={styles.providerImg} src={provider_profile_image_url} alt={name} />
            <p className={styles.providerName}>{name}</p>
          </Button>
        ))}
    </SelectorContainer>
  );
};
